import type { ReactNode } from 'react';

interface AppShellProps {
  children: ReactNode;
}

/**
 * AppShell wraps every page. It:
 * - Constrains width to mobile max
 * - Respects iOS/Android safe-area insets
 * - Provides top/bottom layout slots for nav (added later)
 */
export function AppShell({ children }: AppShellProps) {
  return (
    <div style={styles.shell}>
      <main style={styles.main}>{children}</main>
    </div>
  );
}

const styles = {
  shell: {
    display: 'flex',
    flexDirection: 'column' as const,
    minHeight: '100dvh',
    maxWidth: 'var(--max-width)',
    margin: '0 auto',
    position: 'relative' as const,
    paddingTop: 'var(--safe-top)',
    paddingBottom: 'var(--safe-bottom)',
    paddingLeft: 'var(--safe-left)',
    paddingRight: 'var(--safe-right)',
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    overflowY: 'auto' as const,
  },
};
